
<google-map
        *ngIf="googleMap()"
        height="200px"
        width="100%"
        [options]="{
                disableDefaultUI: true,
                scrollwheel: false,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: true,

            }"
>
    <map-marker *ngFor="let marker of markers()" [position]="marker.position" [options]="marker?.options" />

  <map-directions-renderer *ngIf='completedDirections() as completedDirections'
                           [directions]='completedDirections | async'>
  </map-directions-renderer>

</google-map>
